import styled from 'styled-components';
import { Dialog, IconButton } from 'cdk-radial';

export const StyledDiv = styled.div`
 display: flex;
 padding: 50px 16px 16px 5px;
 @media (max-width: 625px) {
    display: flex;
    padding: 50px 16px 16px 0px;
  }
`

export const StyledAllButtonDiv = styled.div`
 display: flex;
 justify-content: flex-end;
 padding: 50px 16px 16px 5px;
 @media (max-width: 625px) {
    display: flex;
    padding: 50px 16px 16px 0px;
  }
`

export const StyledButtonDiv = styled.div`
display: flex;
 @media (max-width: 750px) {
    padding-left: 10px;
  }
@media (max-width: 600px) {
    display: block;
  }
`

export const StyledApplicationDialog = styled(Dialog)`
  min-width: 580px;
  max-width: 700px;
  width: 50vw;
  margin-top: 60px;
  z-index: 9999;
  max-height: 400px;
  font-size: 24px;
  font-weight: 800;

  @media (max-width: 1350px) {
    width: 92vw;
  }
  @media (max-width: 470px) {
    min-width: 10vw;
    max-width: 100%;
    width: 80vw;
    top: 310px;
    height: 450px;
    max-height: 500px;
  }
  @media (max-width: 580px) {
    min-width: 10vw;
    max-width: 100%;
    width: 92vw;
    height: 450px;
    max-height: 500px;
  }
`;

export const CardHeader = styled.div`
  font-family: 'Montserrat', 'Roboto', sans-serif;
  display: flex;
  align-items: center;
  gap: 10px 8px;
  font-weight: 600;
`;

export const ProductIcon = styled.div<{ iconColor: string }>`
  font-family: 'Montserrat', 'Roboto', sans-serif;
  display: flex;
  padding: 0.16rem;
  align-items: flex-start;
  background-color: ${({ iconColor }) => iconColor};
  border-radius: 4px;
  box-sizing: border-box;
  color: #fff;
  grid-area: 1/1;
  flex-direction: row-reverse;
  flex-wrap: wrap-reverse;
  font-size: 28px;
  font-weight: 400;
  height: 68px;
  letter-spacing: -0.06em;
  overflow-wrap: anywhere;
  overflow: hidden;
  text-align: end;
  width: 68px;
    @media (max-width: 430px) {
    font-size: 20px;
  }
`;

export const CardTitle = styled.div`
  font-family: 'Montserrat', 'Roboto', sans-serif;
  display: flex;
  flex-direction: column;
  font-size: 16px;
`;

export const RoundedIconButton = styled(IconButton) <{
  darkMode: boolean;
}>`
  border-radius: 36px;
  &&& {
    svg {
      fill: ${({ darkMode }) => (darkMode ? '#E6E6E6' : '#333')};
      transition-property: all;
      :hover {
        background-color: ${({ darkMode }) => (darkMode ? '#333' : '#E6E6E6')};
        fill: ${({ darkMode }) => (darkMode ? '#F2F2F2' : '#333')};
      }
      :active {
        background-color: ${({ darkMode }) => (darkMode ? '#4D4D4D' : '#CCC')};
      }
    }
    :hover {
      background-color: ${({ darkMode }) => (darkMode ? '#333' : '#E6E6E6')};
    }
    :active {
      background-color: ${({ darkMode }) => (darkMode ? '#4D4D4D' : '#CCC')};
    }
   :focus-visible {
      background-color: ${({ darkMode }) => (darkMode ? '#333' : '#E6E6E6')};
      box-shadow: 0 0 0 1px rgb(99, 99, 114);
    }
  }
  @media (max-width: 470px) {
    min-width: 1rem;
    &&& {
      svg {
        :hover {
          background-color: transparent;
        }
      }

      :hover {
        background-color: transparent;
      }

      :focus-visible {
        background-color: transparent;
      }
    }
  }
`;